// User Types
export const USER_TYPES = {
  VOLUNTEER: 'volunteer',
  ORG_ADMIN: 'org-admin',
  PLATFORM_ADMIN: 'platform-admin',
};

// User Status
export const USER_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
};

// Organization Status
export const ORG_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
};

// Event Categories
export const EVENT_CATEGORIES = {
  ENVIRONMENT: 'environment',
  EDUCATION: 'education',
  HEALTH: 'health',
  COMMUNITY: 'community',
  OTHER: 'other',
};

export const EVENT_CATEGORY_LABELS = {
  [EVENT_CATEGORIES.ENVIRONMENT]: 'Environment',
  [EVENT_CATEGORIES.EDUCATION]: 'Education',
  [EVENT_CATEGORIES.HEALTH]: 'Health',
  [EVENT_CATEGORIES.COMMUNITY]: 'Community',
  [EVENT_CATEGORIES.OTHER]: 'Other',
};

// Event Status
export const EVENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

// Registration/Assignment Status
export const ASSIGNMENT_STATUS = {
  ASSIGNED: 'assigned',
  COMPLETED: 'completed',
  REPLACED: 'replaced',
  CANCELLED: 'cancelled',
};

// Assignment Types
export const ASSIGNMENT_TYPES = {
  SELF_SIGNUP: 'self-signup',
  ADMIN_ASSIGNED: 'admin-assigned',
};

// Notification Types
export const NOTIFICATION_TYPES = {
  EVENT_APPROVED: 'event-approved',
  EVENT_REMINDER: 'event-reminder',
  ASSIGNMENT_CREATED: 'assignment-created',
  ASSIGNMENT_CANCELLED: 'assignment-cancelled',
  REPLACEMENT_REQUESTED: 'replacement-requested',
  REPLACEMENT_FILLED: 'replacement-filled',
};

// Days of Week
export const DAYS_OF_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const DAY_LABELS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

// Time Periods
export const TIME_PERIODS = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
};

export const TIME_PERIOD_LABELS = {
  [TIME_PERIODS.MORNING]: 'Morning (6AM - 12PM)',
  [TIME_PERIODS.AFTERNOON]: 'Afternoon (12PM - 6PM)',
  [TIME_PERIODS.EVENING]: 'Evening (6PM - 12AM)',
};

// Common Skills for Volunteers
export const VOLUNTEER_SKILLS = [
  'First Aid',
  'CPR Certified',
  'Teaching',
  'Cooking',
  'Event Planning',
  'Public Speaking',
  'Fundraising',
  'Marketing',
  'Social Media',
  'Photography',
  'Videography',
  'Graphic Design',
  'Web Development',
  'Translation',
  'Driving',
  'Heavy Lifting',
  'Construction',
  'Gardening',
  'Animal Care',
  'Childcare',
  'Senior Care',
  'Counseling',
  'Legal',
  'Accounting',
  'Other',
];

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  EVENTS: '/events',
  EVENT_DETAILS: '/events/:eventId',
  CREATE_EVENT: '/events/create',
  EDIT_EVENT: '/events/:eventId/edit',
  SCHEDULE: '/schedule',
  PROFILE: '/profile',
};

// Default Availability (all false initially)
export const DEFAULT_AVAILABILITY = DAYS_OF_WEEK.reduce((acc, day) => {
  acc[day] = {
    morning: false,
    afternoon: false,
    evening: false,
  };
  return acc;
}, {});

// Pagination
export const ITEMS_PER_PAGE = {
  EVENTS: 12,
  VOLUNTEERS: 20,
  NOTIFICATIONS: 15,
};

// File Upload Limits (in MB)
export const FILE_UPLOAD_LIMITS = {
  PROFILE_PHOTO: 5,
  EVENT_IMAGE: 10,
  ORG_LOGO: 10,
};

export default {
  USER_TYPES,
  USER_STATUS,
  ORG_STATUS,
  EVENT_CATEGORIES,
  EVENT_CATEGORY_LABELS,
  EVENT_STATUS,
  ASSIGNMENT_STATUS,
  ASSIGNMENT_TYPES,
  NOTIFICATION_TYPES,
  DAYS_OF_WEEK,
  DAY_LABELS,
  TIME_PERIODS,
  TIME_PERIOD_LABELS,
  VOLUNTEER_SKILLS,
  ROUTES,
  DEFAULT_AVAILABILITY,
  ITEMS_PER_PAGE,
  FILE_UPLOAD_LIMITS,
};
